import React, { useEffect, useState } from 'react';

import Axios from 'axios';
import _ from 'lodash';
import moment from 'moment';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';

import Config from '../config';
import Utils from '../Utils';

const LogsOrders = () => {
    const [logsCount, setLogsCount] = useState();
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        page: 1,
        sortField: 'id',
        sortOrder: -1,
        /*
        filters: {
          'aic': { value: null, matchMode: 'equals' },
          'type': { value: null, matchMode: 'equals' },
          'source': { value: null, matchMode: 'equals' }
        }
        */
    });

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const loadLazyData = () => {
        setLoading(true);

        Axios.post(Config.API_BASE_URL+"/api/logs/orders", lazyParams)
            .then(result => result.data)
            .then(result => {
                setLogs(result.data.rows);
                setLogsCount(result.data.count);
                setLoading(false);
            });
    };

    const onFilter = params => {
        setLazyParams(_.merge(params, { first: 0 }));
    }
    const onSort = params => setLazyParams(params);
    const onPage = params => setLazyParams(params);

    const typeRowFilterTemplate = options => (
        <Dropdown
          value={options.value}
          options={['quantity', 'price']}
          onChange={(e) => options.filterApplyCallback(e.value)}
          placeholder="Scegli un tipo"
          className="p-column-filter"
        />
    );
    const sourceRowFilterTemplate = options => (
        <Dropdown
          value={options.value}
          options={['eBay Italia', 'eBay Estero', 'Amazon Italia', 'Amazon Estero', 'Website Italia', 'Website Estero']}
          onChange={(e) => options.filterApplyCallback(e.value)}
          placeholder="Scegli un'origine"
          className="p-column-filter"
        />
    );

    const totalPriceFilterTemplate = (options) => {
        return <InputNumber value={options.value} onChange={(e) => options.filterCallback(e.value, options.index)} mode="currency" currency="EUR" locale="it-IT" />
    }

    const rowDatetime = row => moment(row.datetime).format('D MMM HH:mm:ss');
    const rowSource = row => row.context.source;
    const rowCustomer = row => _.get(row.context, ['customer', 'name'], row.message);
    const rowTotalPrice = row => Utils.formatCurrency(row.context.total_price);

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Log sincronizzazione ordini</h5>
                    <DataTable
                      className="p-datatable-gridlines"
                      responsiveLayout="scroll"
                      lazy
                      dataKey="id"
                      value={logs}
                      paginator
                      showGridlines
                      first={lazyParams.first}
                      rows={lazyParams.rows}
                      totalRecords={logsCount}
                      filters={lazyParams.filters}
                      filterDisplay="row"
                      onFilter={onFilter}
                      sortField={lazyParams.sortField}
                      sortOrder={lazyParams.sortOrder}
                      onSort={onSort}
                      onPage={onPage}
                      loading={loading}
                      emptyMessage="Nessun log trovato."
                    >
                      <Column field="id" body={rowDatetime} header="Data e ora" sortable />
                      <Column field="source" body={rowSource} filter showFilterMenu={false} filterElement={sourceRowFilterTemplate} header="Origine" />
                      <Column field="customer" header="Cliente" body={rowCustomer} filter showFilterMenu={false} />
                      <Column field="total_price" header="Prezzo" body={rowTotalPrice} dataType="numeric" sortable filter filterElement={totalPriceFilterTemplate} />

                      {/*
                      <Column field="id" body={rowDatetime} header="Data e ora" sortable />
                      <Column key="aic" body={rowAIC} header="AIC" field="aic" filter showFilterMenu={false} />
                      <Column field="type" body={rowType} filter showFilterMenu={false} filterElement={typeRowFilterTemplate} header="Tipo" />
                      <Column body={rowData} header="Dati" />
                      <Column field="source" body={rowSource} filter showFilterMenu={false} filterElement={sourceRowFilterTemplate} header="Origine" />
                      */}
                      {/*
                      <Column field="message" header="Messaggio" />
                      {/*
                      <Column field="name" header="Name" filter filterPlaceholder="Search by name" style={{ minWidth: '12rem' }} />
                      <Column header="Country" filterField="country.name" style={{ minWidth: '12rem' }} body={countryBodyTemplate} filter filterPlaceholder="Search by country"
                          filterClear={filterClearTemplate} filterApply={filterApplyTemplate} />
                      <Column header="Agent" filterField="representative" showFilterMatchModes={false} filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '14rem' }} body={representativeBodyTemplate}
                          filter filterElement={representativeFilterTemplate} />
                      <Column header="Date" filterField="date" dataType="date" style={{ minWidth: '10rem' }} body={dateBodyTemplate}
                          filter filterElement={dateFilterTemplate} />
                      <Column header="Balance" filterField="balance" dataType="numeric" style={{ minWidth: '10rem' }} body={balanceBodyTemplate} filter filterElement={balanceFilterTemplate} />
                      <Column field="status" header="Status" filterMenuStyle={{ width: '14rem' }} style={{ minWidth: '12rem' }} body={statusBodyTemplate} filter filterElement={statusFilterTemplate} />
                      <Column field="activity" header="Activity" showFilterMatchModes={false} style={{ minWidth: '12rem' }} body={activityBodyTemplate} filter filterElement={activityFilterTemplate} />
                      <Column field="verified" header="Verified" dataType="boolean" bodyClassName="text-center" style={{ minWidth: '8rem' }} body={verifiedBodyTemplate} filter filterElement={verifiedFilterTemplate} />
                      */}
                    </DataTable>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(LogsOrders, comparisonFn);
